import { FC, memo } from 'react';
import { INCOME } from '@doda/common/src/constants/screenStructure/searchConditionItems';
import { ConditionsAreaWrapper } from 'components/SearchSideBar/ConditionsAreaWrapper';
import { Error } from '@doda/io-react/common';
import styles from './index.module.scss';
import { SearchConditionTitle } from '../SearchConditionTitle';
import { SearchIncomeSelect } from './SearchIncomeSelect';

/**
 * Props
 * @param defaultValue 初期値
 * @param isIncomeRangeError バリデーションエラーか
 * @param onChangeUpperIncome 年収（上限）の更新処理
 * @param onChangeLowerIncome 年収（下限）の更新処理
 * @param onChangeIsShowOverlay オーバーレイ表示処理
 */
interface Props {
  defaultValue: {
    upper: string;
    lower: string;
  };
  isIncomeRangeError: boolean;
  onChangeUpperIncome: (value: string) => void;
  onChangeLowerIncome: (value: string) => void;
  onChangeIsShowOverlay: () => void;
}

/**
 * 検索サイトバー・年収
 */
export const SearchIncome: FC<Props> = memo(
  ({
    isIncomeRangeError,
    defaultValue,
    onChangeUpperIncome,
    onChangeLowerIncome,
    onChangeIsShowOverlay,
  }) => {
    return (
      <ConditionsAreaWrapper>
        <SearchConditionTitle title={INCOME.title} />
        {!isIncomeRangeError && (
          <div className={styles.searchIncome__error}>
            <Error size="S" />
            正しい範囲を指定してください
          </div>
        )}
        <div className={styles.searchIncome__wrapper}>
          <SearchIncomeSelect
            isUpper
            onChange={(value) => {
              onChangeLowerIncome(value);
              onChangeIsShowOverlay();
            }}
            defaultValue={defaultValue.lower}
          />
          <SearchIncomeSelect
            isUpper={false}
            onChange={(value) => {
              onChangeUpperIncome(value);
              onChangeIsShowOverlay();
            }}
            defaultValue={defaultValue.upper}
          />
        </div>
      </ConditionsAreaWrapper>
    );
  }
);

SearchIncome.displayName = 'SearchIncome';
